export const formatDocuments = (docs) => {
  let docsObj = {
    documentNames: [],
    documentSize: [],
    documentTypeNames: [],
    docReceivedDates: [],
    disputeStageNames: [],
    imageToolKitData: [],
    pageCount: [],
    pageListArray: [],
    selectAllFlag: [],
  };

  if (docs.length > 0) {
    let currDocpageListArr;
    docs.forEach((file) => {
      currDocpageListArr = file.base64.reduce(
        (acc, curr, currIndex) => [
          ...acc,
          {
            pageId: currIndex,
            pageContent: curr,
            docId: file.docId,
            documentName: file.documentName,
            documentType: file.documentType,
          },
        ],
        [],
      );
      docsObj = {
        ...docsObj,
        documentNames: [...docsObj.documentNames, file.documentName],
        documentSize: [...docsObj.documentSize, file.documentSize],
        documentTypeNames: [...docsObj.documentTypeNames, file.documentType],
        docReceivedDates: [...docsObj.docReceivedDates, file.documentReceivedDate],
        disputeStageNames: [...docsObj.disputeStageNames, file.disputeStageName],
        imageToolKitData: [...docsObj.imageToolKitData, file.base64],
        pageCount: [...docsObj.pageCount, 0],
        pageListArray: [...docsObj.pageListArray, currDocpageListArr],
        selectAllFlag: [...docsObj.selectAllFlag, false],
      };
    });
  }
  return docsObj;
};
